export default __webpack_public_path__ + "static/media/p14.4c974f70.jpg";